/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'

const MonthlyClosingDetailState = Record({
  id: null,
  monthly_closing_head_id: null,
  account_title_group_id: null,
  account_title_id: null,
  account_title_detail_id: null,
  occurred_on: null,
  price: 0,
  remarks: ''
})

export { MonthlyClosingDetailState }
